export interface VideoCategory {
  id: string;
  name: string;
  slug: string;
  icon: string;
}

export const videoCategories: VideoCategory[] = [
  { id: '1', name: '电视剧', slug: 'dianshiju', icon: 'ri-tv-line' },
  { id: '2', name: '电影', slug: 'dianying', icon: 'ri-film-line' },
  { id: '3', name: '综艺', slug: 'zongyi', icon: 'ri-live-line' },
  { id: '4', name: '动漫', slug: 'dongman', icon: 'ri-rocket-line' },
  { id: '5', name: '纪录片', slug: 'jilupian', icon: 'ri-camera-lens-line' },
  { id: '6', name: '少儿', slug: 'shaoer', icon: 'ri-heart-line' },
  { id: '7', name: '游戏', slug: 'youxi', icon: 'ri-gamepad-line' },
  { id: '8', name: '体育', slug: 'tiyu', icon: 'ri-basketball-line' },
];

export interface Video {
  id: string;
  title: string;
  categoryId: string;
  categoryName: string;
  thumbnail: string;
  duration: string;
  views: number;
  rating: number;
  year: number;
  description: string;
  isHot: boolean;
  isNew: boolean;
  tags: string[];
}

export const videos: Video[] = [
  {
    id: '1',
    title: '长安十二时辰',
    categoryId: '1',
    categoryName: '电视剧',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20drama%20poster%20with%20Tang%20Dynasty%20warriors%20in%20armor%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20warm%20golden%20tones%2C%20epic%20historical%20atmosphere%2C%20movie%20poster%20style%20with%20Chinese%20calligraphy%20title%2C%20dark%20moody%20background%20with%20amber%20accents&width=800&height=450&seq=douhua-video-01&orientation=landscape',
    duration: '45分钟',
    views: 12800000,
    rating: 9.2,
    year: 2024,
    description: '讲述了唐朝天宝年间，上元节前夕，长安城陷入危局，死囚张小敬临危受命，与少年名士李必携手在十二时辰内拯救长安的故事。',
    isHot: true,
    isNew: false,
    tags: ['古装', '悬疑', '历史'],
  },
  {
    id: '2',
    title: '流浪地球3',
    categoryId: '2',
    categoryName: '电影',
    thumbnail: 'https://readdy.ai/api/search-image?query=Sci-fi%20movie%20poster%20with%20giant%20spaceship%20and%20Earth%20in%20deep%20space%2C%20cinematic%20blue%20and%20orange%20lighting%2C%20epic%20scale%2C%20dramatic%20composition%2C%20futuristic%20technology%2C%20movie%20poster%20style%20with%20glowing%20engines%20and%20stars&width=800&height=450&seq=douhua-video-02&orientation=landscape',
    duration: '148分钟',
    views: 35600000,
    rating: 9.5,
    year: 2025,
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，开启了一场跨越2500年的星际流浪之旅。第三部将揭示人类文明的终极命运。',
    isHot: true,
    isNew: true,
    tags: ['科幻', '冒险', '灾难'],
  },
  {
    id: '3',
    title: '乘风破浪的姐姐 第五季',
    categoryId: '3',
    categoryName: '综艺',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20stage%20with%20female%20performers%20in%20elegant%20dresses%2C%20sparkling%20stage%20lights%2C%20glamorous%20atmosphere%2C%20warm%20spotlight%2C%20entertainment%20show%20poster%20style%2C%20golden%20and%20pink%20tones&width=800&height=450&seq=douhua-video-03&orientation=landscape',
    duration: '90分钟',
    views: 22500000,
    rating: 8.8,
    year: 2025,
    description: '30位30+姐姐重新出发，用实力打破年龄界限，展现女性独特魅力与无限可能。全新赛制更加激烈精彩！',
    isHot: true,
    isNew: true,
    tags: ['真人秀', '音乐', '女性'],
  },
  {
    id: '4',
    title: '斗罗大陆之绝世唐门',
    categoryId: '4',
    categoryName: '动漫',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20donghua%20poster%20with%20martial%20arts%20hero%20in%20colorful%20fantasy%20armor%2C%20magical%20energy%20effects%2C%20dynamic%20action%20pose%2C%20vibrant%20colors%2C%20anime%20art%20style%2C%20epic%20fantasy%20world%20background&width=800&height=450&seq=douhua-video-04&orientation=landscape',
    duration: '22分钟',
    views: 18900000,
    rating: 9.0,
    year: 2025,
    description: '霍雨浩在史莱克学院开启全新的冒险之旅，万年魂兽、绝世武魂，少年与伙伴们并肩作战的热血故事。',
    isHot: true,
    isNew: false,
    tags: ['热血', '玄幻', '冒险'],
  },
  {
    id: '5',
    title: '舌尖上的中国 第四季',
    categoryId: '5',
    categoryName: '纪录片',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%20with%20steaming%20hot%20traditional%20dishes%20on%20wooden%20table%2C%20warm%20natural%20lighting%2C%20rich%20colors%20of%20fresh%20ingredients%2C%20rustic%20kitchen%20background%2C%20appetizing%20food%20photography%2C%20cultural%20cooking%20atmosphere&width=800&height=450&seq=douhua-video-05&orientation=landscape',
    duration: '50分钟',
    views: 15600000,
    rating: 9.7,
    year: 2024,
    description: '深入中国各地，探寻最地道的美食文化，讲述食物背后的人文故事与乡土情怀。',
    isHot: false,
    isNew: false,
    tags: ['美食', '文化', '人文'],
  },
  {
    id: '6',
    title: '熊出没之重返地球',
    categoryId: '6',
    categoryName: '少儿',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20bears%20in%20colorful%20forest%20adventure%2C%20children%20animation%20poster%20style%2C%20bright%20cheerful%20colors%2C%20friendly%20characters%2C%20whimsical%20nature%20background%2C%20fun%20and%20playful%20atmosphere%2C%20animated%20movie%20poster&width=800&height=450&seq=douhua-video-06&orientation=landscape',
    duration: '99分钟',
    views: 8900000,
    rating: 8.5,
    year: 2024,
    description: '光头强和熊大熊二意外卷入一场外星冒险，为了保护地球家园，他们团结一致对抗外星机器人。',
    isHot: false,
    isNew: false,
    tags: ['动画', '喜剧', '冒险'],
  },
  {
    id: '7',
    title: '英雄联盟全球总决赛',
    categoryId: '7',
    categoryName: '游戏',
    thumbnail: 'https://readdy.ai/api/search-image?query=Esports%20arena%20with%20massive%20LED%20screens%20showing%20League%20of%20Legends%20gameplay%2C%20packed%20stadium%20crowd%2C%20dramatic%20stage%20lighting%2C%20blue%20and%20gold%20color%20scheme%2C%20competitive%20gaming%20atmosphere%2C%20championship%20event&width=800&height=450&seq=douhua-video-07&orientation=landscape',
    duration: '180分钟',
    views: 45200000,
    rating: 9.8,
    year: 2025,
    description: '全球顶级战队齐聚，争夺召唤师奖杯的至高荣耀。精彩比赛、震撼开幕式，电竞盛宴不容错过。',
    isHot: true,
    isNew: true,
    tags: ['电竞', '竞技', '直播'],
  },
  {
    id: '8',
    title: 'NBA季后赛 2025',
    categoryId: '8',
    categoryName: '体育',
    thumbnail: 'https://readdy.ai/api/search-image?query=NBA%20basketball%20playoff%20action%20shot%20with%20player%20dunking%2C%20dramatic%20arena%20lighting%2C%20intense%20sports%20photography%2C%20hardwood%20court%2C%20packed%20stadium%2C%20dynamic%20motion%2C%20orange%20basketball%20in%20focus%2C%20sports%20poster%20style&width=800&height=450&seq=douhua-video-08&orientation=landscape',
    duration: '150分钟',
    views: 19800000,
    rating: 9.4,
    year: 2025,
    description: '2025赛季NBA季后赛激战正酣，东西部豪强捉对厮杀，谁能问鼎总冠军？',
    isHot: true,
    isNew: false,
    tags: ['篮球', '竞技', '直播'],
  },
  {
    id: '9',
    title: '庆余年 第二季',
    categoryId: '1',
    categoryName: '电视剧',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%20with%20handsome%20scholar%20in%20traditional%20robe%2C%20ink%20wash%20painting%20style%20background%2C%20elegant%20ancient%20Chinese%20aesthetic%2C%20soft%20golden%20lighting%2C%20mysterious%20atmosphere%2C%20palace%20intrigue%20theme&width=800&height=450&seq=douhua-video-09&orientation=landscape',
    duration: '45分钟',
    views: 29500000,
    rating: 9.3,
    year: 2025,
    description: '范闲从北齐归来后，发现自己身世背后的惊天秘密，朝堂之上的暗流涌动更加汹涌。',
    isHot: true,
    isNew: true,
    tags: ['古装', '权谋', '玄幻'],
  },
  {
    id: '10',
    title: '哪吒之魔童闹海',
    categoryId: '2',
    categoryName: '电影',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20with%20mythological%20boy%20warrior%20with%20fire%20wheel%2C%20dynamic%20red%20silk%20ribbon%2C%20epic%20battle%20scene%2C%20vibrant%20colors%2C%20traditional%20Chinese%20mythology%20style%2C%20dramatic%20lighting%2C%20ocean%20and%20sky%20background&width=800&height=450&seq=douhua-video-10&orientation=landscape',
    duration: '110分钟',
    views: 52000000,
    rating: 9.6,
    year: 2025,
    description: '哪吒与敖丙联手对抗四海龙王，一场关乎陈塘关命运的终极大战即将爆发。国漫巅峰之作！',
    isHot: true,
    isNew: true,
    tags: ['动画', '神话', '动作'],
  },
  {
    id: '11',
    title: '密室大逃脱 第六季',
    categoryId: '3',
    categoryName: '综艺',
    thumbnail: 'https://readdy.ai/api/search-image?query=Mystery%20escape%20room%20TV%20show%20set%20with%20dim%20atmospheric%20lighting%2C%20puzzle%20elements%2C%20suspenseful%20mood%2C%20entertainment%20show%20poster%2C%20dark%20and%20mysterious%20tones%2C%20team%20of%20celebrities%20solving%20clues&width=800&height=450&seq=douhua-video-11&orientation=landscape',
    duration: '75分钟',
    views: 11200000,
    rating: 8.7,
    year: 2025,
    description: '全新升级的密室挑战，更烧脑的谜题，更惊险的机关，明星嘉宾们能否成功逃脱？',
    isHot: false,
    isNew: true,
    tags: ['真人秀', '解谜', '冒险'],
  },
  {
    id: '12',
    title: '凡人修仙传 年番',
    categoryId: '4',
    categoryName: '动漫',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20anime%20poster%20with%20swordsman%20flying%20on%20sword%20in%20misty%20mountain%2C%20celestial%20atmosphere%2C%20traditional%20Chinese%20ink%20style%2C%20ethereal%20lighting%2C%20fantasy%20immortal%20world%2C%20flowing%20robes&width=800&height=450&seq=douhua-video-12&orientation=landscape',
    duration: '20分钟',
    views: 16700000,
    rating: 9.1,
    year: 2025,
    description: '平凡少年韩立踏入修仙之路，从一介凡人到三界至尊的传奇旅程。年度必追国漫！',
    isHot: true,
    isNew: false,
    tags: ['仙侠', '修真', '冒险'],
  },
];